'use client';

import React from 'react';
import { MapControlsProvider } from './MapControlsContext';

export default function MapWrapper({ children }: { children: React.ReactNode }) {
  return (
    <MapControlsProvider>
      {children}
    </MapControlsProvider>
  );
}